/**
 * functions
 */
import { updateLazy } from "Functions/lazy";
import { initTippy, tippyAlert, initHeaderActionTippy } from "Functions/tippy";
import smoothscroll from "smoothscroll-polyfill";

/**
 * common & components
 */
import "Common/validate-defaults";
import "Common/eshop";
import "Common/window";
import "Common/info-messages";
import "Common/form-addons";
import "Common/toggle-password";

import "Common/product-cart-quantity";
import "Common/spinner-quick-update";

import "Components/modal/modal-back";
import "Components/modal/modal-jump";
import "Components/modal/modal-open-from-hash";

import "Components/header";
import "Components/footer";
import "Components/form/login";

/**
 * script
 */
window.Cart.customCallbacks.addedItem = function (form, response) {
    window.rEvent.dispatch("Custom.Cart.addedItem", { form, response });
};
window.Cart.customCallbacks.updatedItem = function (input, response) {
    window.rEvent.dispatch("Custom.Cart.updatedItem", { input, response });
};
window.Cart.customCallbacks.removedItem = function (form, response) {
    window.rEvent.dispatch("Custom.Cart.removedItem", { form, response });
};

window.updateLazy = updateLazy();

document.addEventListener("DOMContentLoaded", () => {
    updateLazy();
    initTippy();
    initHeaderActionTippy();
    initTippy(".js-tippy-availability", {
        theme: "availability",
        maxWidth: "520px",
    });
});

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".js-back").forEach((back) => {
        back.addEventListener("click", (event) => {
            if (event.currentTarget.getAttribute("href") == "#") {
                window.history.back();
            }
        });
    });
});

smoothscroll.polyfill();

// Comparison badge in header
const compareAddItem = Compare.addItem;
Compare.addItem = (form) => {
    form.querySelector('[type="submit"]').classList.add("is-loading");

    return compareAddItem(form);
};

const compareToggleItem = Compare.toggleItem;
Compare.toggleItem = (form) => {
    form.querySelector('[type="submit"]').classList.add("is-loading");

    return compareToggleItem(form);
};

Compare.callbacks.addedItem = function (form, response) {
    form.querySelector('[type="submit"]').classList.remove("is-loading");

    tippyAlert(form, response.message, {
        type: response.status ? "success" : "error",
    });

    if (!response.status) {
        return;
    }

    document.querySelectorAll(".js-compare-badge").forEach((badge) => {
        badge.innerHTML = response.count;
        badge.dataset.count = response.count;
    });

    Compare.customCallbacks.addedItem(form, response);
};

Compare.callbacks.toggledItem = function (form, response) {
    form.querySelector('[type="submit"]').classList.remove("is-loading");

    tippyAlert(form, response.message, {
        type: response.status ? "success" : "error",
    });

    if (!response.status) {
        return;
    }

    document.querySelectorAll(".js-compare-badge").forEach((badge) => {
        badge.innerHTML = response.count;
        badge.dataset.count = response.count;
    });

    form.querySelector(".c-checkbox").classList.toggle("is-checked", response.action == "add");

    Compare.customCallbacks.toggledItem(form, response);
};
